import { format } from "date-fns";

export const formatToJst = (date: string | Date): string =>
  format(new Date(date), "yyyy-MM-dd'T'HH:mm:00+09:00");
